import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pt-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatButtonModule, NgxSkeletonLoaderModule],
})
export class IconPickerComponent {
  icons = input.required<string[]>();
  selectedIcon = input<string>();
  maxHeight = input('300px');
  iconChange = output<string>();

  selectIcon(icon: string): void {
    this.iconChange.emit(icon);
  }

  isSelected(icon: string): boolean {
    return this.selectedIcon() === icon;
  }
}
